import React from 'react';

export const DefaultIdeaImage = () => (
  <svg
    width="200px"
    height="200px"
    viewBox="0 0 200 200"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <rect id="path-1" x="0" y="0" width="318" height="200" />
      <filter colorInterpolationFilters="auto" id="filter-3">
        <feColorMatrix
          in="SourceGraphic"
          type="matrix"
          values="0 0 0 0 0.466667 0 0 0 0 0.560784 0 0 0 0 0.682353 0 0 0 1.000000 0"
        />
      </filter>
    </defs>
    <g id="ChallengeDefaultColor200x200" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Group-3-Copy-8" transform="translate(-59.000000, 0.000000)">
        <mask id="mask-2" fill="white">
          <use xlinkHref="#path-1" />
        </mask>
        <use id="Rectangle-Copy-41" fill="#F5F6F7" xlinkHref="#path-1" />
        <rect
          id="Rectangle"
          fill="#EBEDF0"
          mask="url(#mask-2)"
          transform="translate(74.779455, 111.000000) rotate(-300.000000) translate(-74.779455, -111.000000) "
          x="42.7794549"
          y="-25"
          width="64"
          height="272"
          rx="32"
        />
        <rect
          id="Rectangle-Copy-4"
          fill="#EBEDF0"
          mask="url(#mask-2)"
          transform="translate(253.779455, 81.000000) rotate(-300.000000) translate(-253.779455, -81.000000) "
          x="221.779455"
          y="-75"
          width="64"
          height="312"
          rx="32"
        />
        <g id="Group" mask="url(#mask-2)">
          <g transform="translate(109.000000, 50.000000)">
            <circle id="Oval" fill="#FFFFFF" cx="50" cy="50" r="50" />
            <g filter="url(#filter-3)" fill="none" id="iconCrowdicity_48" strokeWidth="1">
              <g transform="translate(25.000000, 26.000000)">
                <path
                  d="M25.0434783,27 C22.1384348,27 19.7342609,29.3 19.7342609,32.2 C19.7342609,35.1 22.0382609,37.5 24.9433043,37.5 C27.8483478,37.5 30.2525217,35.2 30.2525217,32.3 L30.2525217,32.3 C30.3526957,29.4 27.9485217,27 25.0434783,27 C25.0434783,27 25.0434783,27 25.0434783,27 Z M42.2733913,30 C40.1697391,30 38.4667826,31.7 38.4667826,33.8 C38.4667826,35.9 40.1697391,37.6 42.2733913,37.6 C44.3770435,37.6 46.08,35.9 46.08,33.9 L46.08,33.9 C46.08,31.7 44.3770435,30 42.2733913,30 C42.3735652,30 42.3735652,30 42.2733913,30 L42.2733913,30 Z M7.81356522,30 C5.70991304,30 4.00695652,31.7 4.00695652,33.8 C4.00695652,35.9 5.70991304,37.6 7.81356522,37.6 C9.91721739,37.6 11.6201739,35.9 11.6201739,33.9 L11.6201739,33.9 C11.52,31.7 9.81704348,30 7.81356522,30 C7.81356522,30 7.81356522,30 7.81356522,30 L7.81356522,30 Z M25.0434783,24 C29.6514783,24 33.357913,27.7 33.357913,32.2 C33.357913,36.8 29.6514783,40.5 25.1436522,40.5 C20.5356522,40.5 16.8292174,36.8 16.8292174,32.3 L16.8292174,32.3 C16.7290435,27.7 20.4354783,24 25.0434783,24 C25.0434783,24 25.0434783,24 25.0434783,24 Z M35.9624348,31.4 C37.2646957,27.9 41.0713043,26.1 44.6775652,27.4 C48.2838261,28.7 49.9867826,32.5 48.6845217,36.1 C48.1836522,37.6 47.0817391,38.9 45.6793043,39.6 C46.6810435,39.9 47.5826087,40.4 48.4841739,41 C49.1853913,41.5 49.2855652,42.4 48.7846957,43.1 C48.2838261,43.8 47.3822609,43.9 46.6810435,43.4 C43.3753043,41 38.6671304,41.7 36.2629565,45 C36.0626087,45.3 35.8622609,45.5 35.762087,45.8 C36.0626087,46.4 35.9624348,47.2 35.3613913,47.6 L35.1610435,47.7 C34.56,48.1 33.6584348,47.9 33.2577391,47.3 C29.5513043,42.7 22.8396522,42 18.2316522,45.7 C17.6306087,46.2 17.1297391,46.7 16.6288696,47.3 C16.128,47.9 15.1262609,48 14.5252174,47.5 C14.0243478,47.1 13.824,46.3 14.1245217,45.7 C13.9241739,45.4 13.824,45.2 13.6236522,44.9 C11.2194783,41.6 6.61147826,40.8 3.20556522,43.2 C2.50434783,43.7 1.60278261,43.5 1.10191304,42.9 C0.801391304,42.4 1.00173913,41.5 1.60278261,41 C2.40417391,40.4 3.40591304,39.9 4.40765217,39.6 C1.20208696,37.7 -1.44328993e-15,33.6 1.90330435,30.4 C3.8066087,27.2 7.91373913,26 11.1193043,27.9 C14.3248696,29.8 15.5269565,33.9 13.6236522,37.1 C13.0226087,38.1 12.1210435,39 11.1193043,39.6 C13.3231304,40.3 15.1262609,41.7 16.4285217,43.6 C21.4372174,39.5 28.6497391,39.5 33.6584348,43.6 C34.9606957,41.7 36.7638261,40.3 38.9676522,39.6 C36.1627826,37.9 34.8605217,34.5 35.9624348,31.4 L35.9624348,31.4 Z"
                  id="Shape"
                  fill="#000000"
                  fillRule="nonzero"
                />
                <path
                  d="M42.0730435,25 C41.7725217,25 41.5721739,24.9 41.3718261,24.8 L34.6601739,21 L31.5547826,21 C30.7533913,21 30.0521739,20.3 30.0521739,19.5 C30.0521739,18.7 30.7533913,18 31.5547826,18 L31.5547826,18 L35.0608696,18 C35.3613913,18 35.5617391,18.1 35.762087,18.2 L40.5704348,20.9 L40.5704348,19.5 C40.5704348,18.7 41.2716522,18 42.0730435,18 L46.08,18 L46.08,9 L42.573913,9 C41.7725217,9 41.0713043,8.3 41.0713043,7.5 C41.0713043,6.7 41.7725217,6 42.573913,6 L47.5826087,6 C48.384,6 49.0852174,6.7 49.0852174,7.5 L49.0852174,19.5 C49.0852174,20.3 48.384,21 47.5826087,21 L43.5756522,21 L43.5756522,23.5 C43.5756522,24.3 42.8744348,25 42.0730435,25 Z"
                  id="Path"
                  fill="#000000"
                  fillRule="nonzero"
                />
                <path
                  d="M8.01391304,25 C7.21252174,25 6.51130435,24.3 6.51130435,23.5 L6.51130435,21 L2.50434783,21 C1.70295652,21 1.00173913,20.3 1.00173913,19.5 L1.00173913,7.5 C1.00173913,6.7 1.70295652,6 2.50434783,6 L7.51304348,6 C8.31443478,6 9.01565217,6.7 9.01565217,7.5 C9.01565217,8.3 8.31443478,9 7.51304348,9 L4.00695652,9 L4.00695652,18 L8.01391304,18 C8.81530435,18 9.51652174,18.7 9.51652174,19.5 L9.51652174,20.9 L14.3248696,18.2 C14.5252174,18.1 14.8257391,18 15.026087,18 L18.5321739,18 C19.3335652,18 20.0347826,18.7 20.0347826,19.5 C20.0347826,20.3 19.3335652,21 18.5321739,21 L15.4267826,21 L8.71513043,24.8 C8.51478261,24.9 8.31443478,25 8.01391304,25 Z"
                  id="Path"
                  fill="#000000"
                  fillRule="nonzero"
                />
                <path
                  d="M25.0434783,20 C24.6427826,20 24.242087,19.8 23.9415652,19.6 L20.4354783,16 L12.5217391,16 C11.7203478,16 11.0191304,15.3 11.0191304,14.5 L11.0191304,14.5 L11.0191304,14.5 L11.0191304,1.5 C11.0191304,0.7 11.7203478,0 12.5217391,0 L37.5652174,0 C38.3666087,0 39.0678261,0.7 39.0678261,1.5 L39.0678261,14.5 C39.0678261,15.3 38.3666087,16 37.5652174,16 L37.5652174,16 L29.6514783,16 L26.0452174,19.6 C25.8448696,19.8 25.4441739,20 25.0434783,20 Z M14.0243478,13 L21.0365217,13 C21.4372174,13 21.837913,13.2 22.1384348,13.4 L25.0434783,16.3 L27.9485217,13.4 C28.2490435,13.1 28.6497391,13 29.0504348,13 L36.0626087,13 L36.0626087,3 L14.0243478,3 L14.0243478,13 Z"
                  id="Shape"
                  fill="#000000"
                  fillRule="nonzero"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
